import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { converterDataHoraBr } from "_utils/Data";
import { IHistoricoLote } from "../../../../../interface/IHistoricoLote";
import {
  ContainerFechar,
  InputWrapper,
  ObservacaoLinha,
  SalvarButton,
  SemRegistros,
  TabelaHistorico,
  TabelaWrapper,
} from "./style";

interface IProps {
  show: boolean;
  idLote: number | null;
  dados: IHistoricoLote | null;
  handleClose: () => void;
  onSalvarObservacao: (observacao: string) => void;
}

export function ModalHistorico({ show, dados, handleClose, onSalvarObservacao }: IProps) {
  const [observacao, setObservacao] = useState("");

  useEffect(() => {
    if (!show) setObservacao("");
  }, [show]);

  const handleSalvar = () => {
    if (!observacao.trim()) return;
    onSalvarObservacao(observacao.trim());
    setObservacao("");
  };

  const eventos = dados?.eventos ?? [];

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      centered
      size="lg"
      title="Histórico de atualizações do lote"
      footer
      footerTools={
        <ContainerFechar>
          <PrimaryButton onClick={handleClose} outline variante="primary">
            Fechar
          </PrimaryButton>
        </ContainerFechar>
      }
    >
      <ObservacaoLinha>
        <InputWrapper>
          <Form.Label>Observação</Form.Label>
          <Form.Control
            type="text"
            placeholder="Inserir nova observação"
            value={observacao}
            onChange={(e) => setObservacao(e.target.value)}
          />
        </InputWrapper>
        <SalvarButton onClick={handleSalvar} disabled={!observacao.trim()}>
          Salvar
        </SalvarButton>
      </ObservacaoLinha>

      <TabelaWrapper>
        <TabelaHistorico>
          <thead>
            <tr>
              <th style={{ width: "160px" }}>Data</th>
              <th style={{ width: "190px" }}>Atualização</th>
              <th style={{ width: "160px" }}>Usuário</th>
              <th>Observação</th>
            </tr>
          </thead>
          <tbody>
            {eventos.map((evento) => (
              <tr key={evento.id}>
                <td>{evento.dataHora ? converterDataHoraBr(evento.dataHora) : "-"}</td>
                <td>{evento.descricao}</td>
                <td>{evento.nomeUsuario ?? "-"}</td>
                <td>{evento.observacao ?? ""}</td>
              </tr>
            ))}
            {!eventos.length && (
              <tr>
                <td colSpan={4}>
                  <SemRegistros>Nenhuma movimentação registrada.</SemRegistros>
                </td>
              </tr>
            )}
          </tbody>
        </TabelaHistorico>
      </TabelaWrapper>
    </ModalCustom>
  );
}
